import { FC } from "react";
import { Modal } from "../../../Modal";
import icon from "../../../../../icons/ok.png";
import { Button } from "../../../../Buttons/Button/Button";
import { ChannelLink } from "../../../../Links/ChannelLink/ChannelLink";

interface IWelcomeBonusNotifyProps {
    closeHandler: () => void;
}

export const TestBBuyFirstDrawNotify: FC<IWelcomeBonusNotifyProps> = ({ closeHandler }) => {
    const getContext = () => {
        return (
            <>
                <p>
                    Следите за результатами розыгрыша в нашем канале <ChannelLink caption="@bizland_com" />
                </p>
                <p>
                    Такие розыгрыши проходят каждый день!
                </p>
                <p>
                    Не забывайте подписываться на новые розыгрыши в разделе «Подарки».
                </p>
            </>
        );
    }

    return (
        <Modal
            name='TestB_BuyFirstDrawNotify'
            title='Вы в списке участников!'
            message={ getContext() }
            icon={icon}
            button={ <Button caption="Закрыть" type="orange" handler={ closeHandler }/> }
        />
    );
}